import { Component } from '@angular/core';
import { Util } from '../../shared/util';
import 'rxjs/add/operator/finally';
import { CustomValidator } from '../../shared/validators/custom.validator';
import { MessageService } from 'primeng/components/common/messageservice';
import { WebPage } from '../../shared/web-page';
import { ClinicaService } from '../clinica.service';

@Component({
  templateUrl: './gerar-requerimento-clinica.component.html'
})
export class GerarRequerimentoClinicaComponent extends WebPage {

  clinica;

  constructor(private _clinicaService: ClinicaService, messageService: MessageService) {
    super(messageService);
  }

  buscarClinicasByCnpj(cnpj: string) {
    if (cnpj.length < 14) {
      this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'CNPJ deve conter pelo menos 14 dígitos' });
      return;
    }

    this.isLoading = true;
    const cnpjLimpo = Util.limpaCnpj(cnpj);
    this._clinicaService.getByCnpj(cnpjLimpo)
      .finally(() => this.isLoading = false)
      .subscribe(
        clinica => {
          if (clinica == null) {
            this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'CNPJ não encontrado!' });
          }

          this.clinica = clinica;
        },
        error => this.gerenciaErro(error)
      );
  }

  gerarRequerimento(idClinicaUnidade) {
    this._clinicaService.gerarRequerimento(idClinicaUnidade);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/clinica/gerar-requerimento-clinica/gerar-requerimento-clinica.component.ts